var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 23.375C11.2837 23.375 12.3337 22.325 12.3337 21.0417H7.66699C7.66699 22.325 8.71699 23.375 10.0003 23.375ZM17.0003 16.375V10.5417C17.0003 6.96 15.0987 3.96167 11.7503 3.16833V2.375C11.7503 1.40667 10.9687 0.625 10.0003 0.625C9.03199 0.625 8.25033 1.40667 8.25033 2.375V3.16833C4.91366 3.96167 3.00033 6.94833 3.00033 10.5417V16.375L0.666992 18.7083V19.875H19.3337V18.7083L17.0003 16.375ZM14.667 17.5417H5.33366V10.5417C5.33366 7.64833 7.09533 5.29167 10.0003 5.29167C12.9053 5.29167 14.667 7.64833 14.667 10.5417V17.5417Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadNotification);
export default __webpack_public_path__ + "static/media/UnreadNotification.6d7ccc4158451898e0f35b6e0ebea623.svg";
export { ForwardRef as ReactComponent };